import { useQuery } from "@tanstack/react-query";
import {
  conceptApi,
  ConceptType,
  CONCEPT_DOMAIN,
  CONCEPT_NOTE_DETAIL_ENDPOINT,
} from "api/conceptApi";
import { convertNoteToReal } from "components/ai/InsideC";
import { useCallback, useState } from "react";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import {
  getAutimaticThoughtIdList,
  getCoreBeliefKeyList,
  getIntermediateBeliefKeyList,
  ThoughtmapStateType,
} from "./getThoughtMapState";

export default function useGetThoughtmapState() {
  const patientState = useRecoilValue(patientAtom);
  const queryFn = useCallback(
    () => conceptApi.noteDetail(`${patientState?.patientId}`),
    [patientState?.patientId]
  );
  const [thoughtmapState, setThoughtmapState] = useState<ThoughtmapStateType>();

  useQuery([CONCEPT_DOMAIN, CONCEPT_NOTE_DETAIL_ENDPOINT], queryFn, {
    onSuccess: (data) => {
      if (data && data.result) {
        const list = data.result;
        const thoughtmapData = convertNoteToReal(list) as ConceptType;
        console.log("HUMAN: ", list, thoughtmapData);

        setThoughtmapState({
          automaticThoughtIdList: getAutimaticThoughtIdList(thoughtmapData),
          intermediateBeliefKeyList:
            getIntermediateBeliefKeyList(thoughtmapData),
          coreBeliefKeyList: getCoreBeliefKeyList(thoughtmapData),
        } as ThoughtmapStateType);
      }
    },
  });

  return thoughtmapState;
}
